
<template>
  <div class="footer pb-4">
    <!-- TODO: refactor markup -->

    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h4 v-translate>About us</h4>
          <ul>
            <li><b-icon icon="house-door"  class="mr-2"/>София, ул. Здраве 9, ет.1, офис 302/9814440,0878/ 886677</li>
            <li><b-icon icon="facebook"  class="mr-2"/><a href="https://www.facebook.com/BGAquaTour/" target="_blank">Facebook Aqua Tour</a></li>
          </ul>
        </div>
        <div class="col-md-6">
          <h4 v-translate>Contact</h4>
          <ul >
            <li><b-icon icon="envelope" class="mr-2"/><a href="mailto:megashop@aqua-tour.net">megashop@aqua-tour.net</a></li>
            <li><b-icon icon="phone"  class="mr-2"/><a href="tel:+029813133">02/981 31 33</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
